import { render } from "./CleanersForm.vue?vue&type=template&id=c83e1de4&ts=true"
import script from "./CleanersForm.vue?vue&type=script&lang=ts"
export * from "./CleanersForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/viper/Projects/topway/topway-accounting-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__